import { formatDate } from '@angular/common';
import { LogService } from '../../../shared/services/log.service';
import { Validator } from '../../../shared/services/validator';
import { CTRL_NAME_EXTRACTOR } from '../ctrl.name.extractor';

export class CTRL_812 implements Validator {

    public static id = 'CTRL_812';
    private message = 'error.ctr_812';


    public LOG: LogService = new LogService(CTRL_812);

    
    validate(form: any, map) {

        
        // vérifier si la règle est applicable sur mon formulaire
        const rgs: string[] = CTRL_NAME_EXTRACTOR.getCtrlNames(form, CTRL_812.id + '_');


        if (rgs.length > 0) {
            for (let rg of rgs) {
                const ctrl = form.controls[rg];
                const firstChampNameWithStepId = map.get(ctrl.value.rgCtrls.firstChamp);
                const firstChampCtrl = form.controls[firstChampNameWithStepId];
                if (firstChampCtrl.value === "" || firstChampCtrl.value === 'yyyy-MM-dd' || firstChampCtrl.value > formatDate(new Date(), 'yyyy-MM-dd', 'en')) {
                    form.controls[rg].value = { rgCtrls: ctrl.value.rgCtrls, ctrlValidation: false };
                } else {
                    // placer le message d'erreur
                    form.controls[rg].value = { rgCtrls: ctrl.value.rgCtrls, ctrlValidation: true, validation_message: this.message };
                }
            }
        }
    }
}
